// The signed-in user's own library (user_uploads): things they generate are
// filed here too, not only what they upload, so a model or sky made for one
// world can be reused in any other. type 'content' shows in the Content
// browser / asset picker; 'skybox' in the sky panel's "Your skies".
import { supabase } from '../config/supabase';
import { AWS_CONFIG } from '../config/aws';

export interface LibraryEntry {
  type: 'content' | 'skybox';
  name: string;
  url: string;
  thumbnailUrl?: string | null;
  mimeType?: string;
  /** Where it came from, e.g. 'studio-picture', 'sky-muse'. */
  source: string;
}

const MIME: Record<string, string> = {
  glb: 'model/gltf-binary', jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp',
};

/** Best effort: a failed save never breaks the thing that was generated. */
export async function saveToMyLibrary(e: LibraryEntry): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user || !e.url) return;
    const extension = (e.url.split('?')[0].split('.').pop() || '').toLowerCase();
    const base = AWS_CONFIG.publicUrl?.replace(/\/+$/, '');
    const key = base && e.url.startsWith(base + '/') ? e.url.slice(base.length + 1) : undefined;
    const { error } = await supabase.from('user_uploads').insert({
      user_id: user.id,
      type: e.type,
      name: e.name.slice(0, 120) || 'Untitled',
      url: e.url,
      thumbnail_url: e.thumbnailUrl ?? null,
      mime_type: e.mimeType ?? MIME[extension] ?? null,
      metadata: { ...(key ? { key } : {}), extension, uploadedAt: Date.now(), source: e.source },
    });
    if (error) console.warn('[myLibrary] save failed:', error.message);
  } catch (err) {
    console.warn('[myLibrary] save failed:', err);
  }
}

export interface MySky { id: string; name: string; url: string; createdAt: number }

export async function listMySkies(limit = 40): Promise<MySky[]> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return [];
  const { data, error } = await supabase
    .from('user_uploads')
    .select('id, name, url, created_at')
    .eq('user_id', user.id)
    .eq('type', 'skybox')
    .order('created_at', { ascending: false })
    .limit(limit);
  if (error) { console.warn('[myLibrary] skies:', error.message); return []; }
  return (data || []).map((r: any) => ({ id: r.id, name: r.name, url: r.url, createdAt: Date.parse(r.created_at) }));
}
